import React, { useContext, useState } from 'react';
import { Card, Alert, CardBody, CardHeader, ListGroup, ListGroupItem, Button, Collapse, Row, Col } from 'reactstrap';
import { useHistory } from 'react-router';

import useResourceLoader from "../util/useResourceLoader";
import useTitle from "../util/useTitle";
import Loader from '../components/Loader';
import CollapsibleCard from '../components/CollapsibleCard';
import ManageFaqApi from '../api/ManageFaqApi';
import InternalLayout from '../components/layouts/InternalLayout';
import Notification from '../components/Notification';
import { AuthContext } from '../context/AuthContext';
import WorkTray from "../components/Dashboard/WorkTray";
import ReportProblemButton from '../components/ReportProblemButton';


const DOCUMENTS = [

    // { title: "Autorización de viajes", url: "https://workdrive.zoho.com/file/aqzr00207ea61d8fc4ef187d0ef859d8865de"},
    // { title: "Bitácoras", url: "https://workdrive.zoho.com/file/aqzr0a6a0a55c9de74abba29f705fa63073f6"},
    // { title: "Onboarding - Gerentes", url: "https://workdrive.zoho.com/file/aqzr05e4cc07139a44da5a7bfb968b372da1b"},
    // { title: "Adiestramiento para Gerentes y Auxiliares", url: "https://dimo.s3.amazonaws.com/faqDocs/Fast+Fleet+Training+para+Gerentes+de+Transporte.pdf"},
    { title: "Fast Fleet - Adiestramiento para Gerentes y Auxiliares", url: "https://dimo.s3.amazonaws.com/faqDocs/Fast+Fleet+Training+para+Gerentes+de+Transporte+V3.pdf"},
    { title: "Fast Fleet - Olvidé mi contraseña", url: "https://dimo.s3.amazonaws.com/faqDocs/Fast+Fleet+-+Ovide+mi+contrasen%CC%83a.pdf"},
    { title: "Fast Fleet - Creación de Tickets", url: "https://dimo.s3.amazonaws.com/faqDocs/Creacio%CC%81n+de+Tickets+-+Fast+Fleet.pdf"},
    { title: "Fast Fleet - Onboarding", url: "https://dimo.s3.amazonaws.com/faqDocs/Onboarding.pdf"},
];


const VIDEOS = [
    { title: "Módulo de Bitácoras", url: "https://www.youtube.com/embed/LbQ4ETjmGho"},
    { title: "Autorización de viajes", url: "https://www.youtube.com/embed/YGjelogfq2I"},
    { title: "Registro de vehículo", url: "https://www.youtube.com/embed/mqybaCPMO2w"},
    { title: "Renovación de marbete", url: "https://www.youtube.com/embed/fYjomZ3YF-E"},
    { title: "Tarjeta de combustible", url: "https://www.youtube.com/embed/e5BcdKMvtng"},
    { title: "¿Cómo anejar documentos?", url: "https://www.youtube.com/embed/u5DNLh7fXss"},
];



export function Faq() {
  const auth = useContext(AuthContext);
  const [isOpenDoc, setIsOpenDoc] = useState(false);
  const [isOpenVid, setIsOpenVid] = useState(false);
  const [isOpenFAQ, setIsOpenFAQ] = useState(false);
  const [isOpenTicket, setIsOpenTicket] = useState(false);

  const toggleDoc = () => setIsOpenDoc(!isOpenDoc);
  const toggleVid = () => setIsOpenVid(!isOpenVid);
  const toggleFAQ = () => setIsOpenFAQ(!isOpenFAQ);
  const toggleTicket = () => setIsOpenTicket(!isOpenTicket);


  const history = useHistory();
  useTitle("Ayuda");
  console.log("+++++++++++++++++++++ auth:",auth);
  const [listFaqs, loadingFaqs] = useResourceLoader(
    () => ManageFaqApi.getFaqs(),
    [], null);

  return (
    <InternalLayout>
      
      <div>
        <h1>Ayuda</h1><br />
        <div>
          {DOCUMENTS.length || VIDEOS.length ? (<>
              {DOCUMENTS.length ? (<>
                <CollapsibleCard title="Documentos">
                  <ListGroup>
                    {DOCUMENTS.map(({title, url}, idx) => (<ListGroupItem key={idx}>
                      <a href={url} target="_blank" rel="noreferrer">{title}</a>
                    </ListGroupItem>))}
                  </ListGroup>
                </CollapsibleCard>
                </>) : null
              }
              {DOCUMENTS.length ? (<>
                  <CollapsibleCard title="Videos de Entrenamiento">
                    <div className="d-flex flex-wrap flex-row">
                      {VIDEOS.map(({title, url}, idx) => (<Card className="mb-4">
                        <CardBody key={idx}>
                          <h4 className="text-default">{title}</h4>
                          <iframe width="560" height="315" src={url} title={title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                        </CardBody>
                      </Card>))}
                    </div>
                  </CollapsibleCard>
                </>) : null
              }
            </>) : null}
        </div> 
      </div>
      {loadingFaqs ? <Loader /> : (
        <>
          <CollapsibleCard title="Preguntas Frecuentes">
            <div className="d-flex flex-wrap flex-row">
            {listFaqs?.length ?
              listFaqs?.map((faq, key) => (
                <FaqCard key={key} faq={faq} />
              )) :
              <Alert color="info">No faqs have been created yet</Alert>
            }
            </div>
          </CollapsibleCard>
        </>
      )}

      {DOCUMENTS.length ? (<>
        <CollapsibleCard title="Tickets">
         <Row>
          <Col md={6} >
              <a href="https://youtu.be/1HBJHWdkXvI?si=GqbH4DJ44iaMTPwe" target="_blank" rel="noreferrer">Video de adiestramiento: ¿Cómo crear un ticket?</a>
          </Col>
          <Col md={6} className="d-flex justify-content-md-end">
            <ReportProblemButton />
          </Col>
        </Row>
        </CollapsibleCard>
        </>) : null
      }
    </InternalLayout>
  )
};

export default Faq;

function FaqCard({
  faq
}) {
  const {
    content,
    createdAt,
  } = faq || {};

  return (
    <Card style={{ padding: 1, marginBlockEnd:20, border: 0, boxShadow: 0, borderBottom: '1.5px solid #ccc' }}>
      <CardHeader>
        <span>{formatDate(createdAt)}</span>
      </CardHeader>
      <CardBody>
        {HTMLCodeDisplay(content)}
      </CardBody>
    </Card>
  );
}

const HTMLCodeDisplay = (htmlCode) => {
  return <div dangerouslySetInnerHTML={{ __html: `<div style="font-family: 'Inter'">${htmlCode}</div>` }} />;
};

const formatDate = (dateStr) => {
  if (!dateStr)
    return "";
  const date = new Date(dateStr);
  const monthAbbr = date.toLocaleString('default', { month: 'short' }).toUpperCase();
  const formattedDate = `${monthAbbr}-${date.getDate()}-${date.getFullYear()}`;
  return formattedDate;
}